import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element, isAuth }) => {
  if (!isAuth) {
    // ❌ If not logged in → redirect to /admin
    return <Navigate to="/admin" replace />;
  }
  return element;
};

export default ProtectedRoute;
